import React from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import EmailCampaignList from "./index";
import CustomEmailList from "../CustomEmail/CustomEmailList";
import { Tabs } from "../CustomEmail/styles";

// Same heading size and spacing as the Custom Email tab.
const ItineraryTab = styled.div`
  & > div > .ant-flex:first-child { margin-bottom: 14px; }
  & > div > .ant-flex:first-child > h3 { margin: 0; font-size: 20px; font-weight: 600; color: #1c2033; }
`;

/** /email_campaign: the existing itinerary campaigns plus the OneSignal custom emails. */
const EmailCampaignTabs = () => {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "custom" ? "custom" : "itinerary";
  const tabs = (
    <Tabs role="tablist">
      <button type="button" role="tab" aria-selected={tab === "itinerary"} onClick={() => setParams({}, { replace: true })}>Itinerary Email</button>
      <button type="button" role="tab" aria-selected={tab === "custom"} onClick={() => setParams({ tab: "custom" }, { replace: true })}>Custom Email</button>
    </Tabs>
  );
  if (tab === "custom") return <CustomEmailList tabs={tabs} />;
  return (
    <ItineraryTab><EmailCampaignList tabs={tabs} /></ItineraryTab>
  );
};

export default EmailCampaignTabs;
